import { createFileRoute } from "@tanstack/react-router";
import { MeowEntityPage } from "@/components/MeowBanking/Entity";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  return <MeowEntityPage entityId={params.entityId} />;
}

export const Route = createFileRoute("/_authenticated/meow-banking/$entityId/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
